import React from 'react'
import { FiInbox } from 'react-icons/fi'
import BranchButton from './BranchButton'

export default function BranchEmptyState({ title = 'No branches found', text = 'Get started by adding your first branch.', actionLabel = '+ Add Branch', actionTo = '/branch-create' }) {
  return (
    <div className='branch-empty'>
      <div className='branch-empty-icon'><FiInbox /></div>
      <div className='branch-empty-title'>{title}</div>
      <div className='branch-empty-text'>{text}</div>
      {actionTo && (
        <BranchButton to={actionTo}>{actionLabel}</BranchButton>
      )}
    </div>
  )
}
